/**
 * Logger conditionnel — les logs ne s'affichent qu'en mode développement.
 * En production, seuls les `error` sont transmis (pour le monitoring).
 *
 * Usage :
 *   import { logger } from '@/lib/logger';
 *   logger.log('📊 data:', data);    // DEV uniquement
 *   logger.warn('⚠️ attention');      // DEV uniquement
 *   logger.error('❌ erreur', err);   // Toujours affiché
 *   logger.debug('détail', obj);      // DEV uniquement
 *   logger.info('ℹ️ info');            // DEV uniquement
 */

const isDev = import.meta.env.DEV;

const noop = (..._args: unknown[]) => {};

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
  // Les erreurs sont toujours affichées, même en production
  error: console.error.bind(console),
};

export default logger;
